import React from "react";
import authImage from "../../../media/img/auth.png";
import avatar01 from "../../../media/img/avators/01.png";
import avatar02 from "../../../media/img/avators/02.png";
import avatar03 from "../../../media/img/avators/03.png";

const AuthShowcase = () => {
  return (
    <div className="hidden lg:flex lg:w-1/2 bg-bg-50 flex-col pl-8 pt-8 pb-8 relative overflow-hidden h-screen">
      {/* Gradient overlay from bottom - covers entire container */}
      <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-bg-50 via-bg-50/30 to-transparent pointer-events-none z-10"></div>
      
      {/* Main Image */}
      <div className="relative flex-1 flex items-center justify-end min-h-0 pb-8">
        <div className="relative max-h-full">
          <img
            src={authImage}
            alt="LeebAI Platform"
            className="max-w-full max-h-full h-auto object-contain"
          />
        </div>
      </div>

      {/* Bottom Content - Fixed to bottom with margin */}
      <div className="space-y-8 pb-6 pr-8 flex-shrink-0 relative z-20">
        {/* Main Text */}
        <div className="text-center">
          <h2 className="text-3xl font-semibold">
            <span className="text-fg-60">One account. All the </span>
            <span className="font-bold text-fg-40">tools</span>
          </h2>
          <h2 className="text-3xl font-semibold text-fg-40">you need.</h2>
        </div>

        {/* Stats Section - Horizontal Layout (temporarily disabled on login page) */}
        {/*
        <div className="flex items-start justify-center gap-32">
          // Left Side: Avatars and Platform Count
          <div className="flex flex-col items-center">
            // Avatars - Fixed Height Container
            <div className="flex -space-x-2 mb-2 h-10">
              <img
                src={avatar01}
                alt="User 1"
                className="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                src={avatar02}
                alt="User 2"
                className="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                src={avatar03}
                alt="User 3"
                className="w-10 h-10 rounded-full border-2 border-white"
              />
            </div>
            // Platform Count Text
            <p className="text-sm font-medium text-fg-60 text-center">
              20,000 banques &<br />platform
            </p>
          </div>

          // Right Side: Rating Section
          <div className="flex flex-col items-center">
            // Stars - Fixed Height Container
            <div className="flex justify-center mb-2 h-10 items-center">
              {[...Array(5)].map((_, i) => (
                <svg
                  key={i}
                  className="w-4 h-4 text-yellow-400 fill-current"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
            // Rating Text
            <p className="text-sm font-medium text-fg-60 text-center">
              Noté 4,5/5 avec<br />5000+avis
            </p>
          </div>
        </div>
        */}
      </div>
    </div>
  );
};

export default AuthShowcase;